import { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { IoTrendingUp, IoCash } from "react-icons/io5";
import { getSummary } from "services/api";

function Income() {
  const [data, setData] = useState(null);

  useEffect(() => {
    getSummary().then(setData);
  }, []);

  if (!data) {
    return (
      <DashboardLayout>
        <DashboardNavbar />
        <VuiBox py={3} display="flex" justifyContent="center" minHeight="60vh">
          <VuiTypography color="white" variant="h5">Loading...</VuiTypography>
        </VuiBox>
      </DashboardLayout>
    );
  }

  const fmt = (n) => Number(n || 0).toLocaleString("en-US", { maximumFractionDigits: 2 });
  const incomeItems = data.income_items || [];
  const creditTotals = data.currency_totals_credit || {};

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <VuiBox py={3}>
        {/* Income Summary Cards */}
        <VuiBox mb={3}>
          <Grid container spacing={3}>
            {Object.entries(creditTotals).map(([cur, total]) => (
              <Grid item xs={12} md={4} key={cur}>
                <Card sx={{ p: 3 }}>
                  <VuiBox display="flex" justifyContent="space-between" alignItems="center">
                    <VuiBox>
                      <VuiTypography variant="caption" color="text" fontWeight="bold" textTransform="uppercase">
                        {cur} Income
                      </VuiTypography>
                      <VuiTypography variant="h4" color="success" fontWeight="bold" mt="4px">
                        {cur === "USD" ? "$" : cur === "GBP" ? "\u00A3" : "Rs."}{fmt(total)}
                      </VuiTypography>
                    </VuiBox>
                    <VuiBox bgColor="success" display="flex" justifyContent="center" alignItems="center"
                      sx={{ borderRadius: "12px", width: "48px", height: "48px" }}>
                      <IoCash color="#fff" size="24px" />
                    </VuiBox>
                  </VuiBox>
                </Card>
              </Grid>
            ))}
            {Object.keys(creditTotals).length === 0 && (
              <Grid item xs={12}>
                <Card sx={{ p: 3 }}>
                  <VuiTypography color="text" variant="button">No income recorded this period</VuiTypography>
                </Card>
              </Grid>
            )}
          </Grid>
        </VuiBox>

        {/* Income Transactions */}
        <Card sx={{ p: 3 }}>
          <VuiTypography variant="lg" color="white" fontWeight="bold" mb="20px">
            Income Transactions
          </VuiTypography>
          {incomeItems.length === 0 ? (
            <VuiTypography color="text" variant="button">No income this month</VuiTypography>
          ) : (
            incomeItems.map((inc, i) => (
              <VuiBox key={i} display="flex" justifyContent="space-between" alignItems="center" py={1.2}
                sx={{ borderBottom: i < incomeItems.length - 1 ? "1px solid rgba(255,255,255,0.05)" : "none" }}>
                <VuiBox display="flex" alignItems="center">
                  <VuiBox bgColor="success" display="flex" justifyContent="center" alignItems="center"
                    sx={{ borderRadius: "10px", width: "36px", height: "36px", mr: 2, flexShrink: 0 }}>
                    <IoTrendingUp color="#fff" size="18px" />
                  </VuiBox>
                  <VuiBox>
                    <VuiTypography variant="button" color="white" fontWeight="medium">
                      {(inc.vendor || "Unknown").slice(0, 40)}
                    </VuiTypography>
                    <VuiTypography variant="caption" color="text" display="block">
                      {inc.date} &middot; via {inc.source}
                    </VuiTypography>
                  </VuiBox>
                </VuiBox>
                <VuiTypography variant="button" color="success" fontWeight="bold">
                  +{inc.currency} {fmt(inc.amount)}
                </VuiTypography>
              </VuiBox>
            ))
          )}
        </Card>
      </VuiBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Income;
